module.exports = __webpack_public_path__ + "static/img/Corey.Dell'Olio.26dda18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Corey.Dell'Olio.jpg
// module id = 0WYM
// module chunks = 0